import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PageShellProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
}

export function PageShell({ title, description, actions, children, className }: PageShellProps) {
  return (
    <div className={cn("space-y-6", className)}>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div className="min-w-0">
          <h2 className="text-2xl font-semibold text-ink">{title}</h2>
          {description && <p className="mt-1 text-sm text-ink-muted max-w-prose">{description}</p>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  );
}

interface ComingSoonProps {
  title: string;
  description: string;
  hint?: string;
}

export function ComingSoon({ title, description, hint }: ComingSoonProps) {
  return (
    <PageShell title={title} description={description}>
      <div className="rounded-lg border border-dashed border-line-strong bg-surface px-6 py-12 text-center">
        <p className="text-md font-medium text-ink">Surface in progress</p>
        <p className="mt-1 text-sm text-ink-muted">
          {hint || "Coming in a later phase of the admin rebuild."}
        </p>
      </div>
    </PageShell>
  );
}
